import React from 'react';
import { conversationWorkspaceStrings } from '../../i18n/conversationWorkspace';
import { useTheme } from '../../theme/ThemeProvider';

interface ToolsPickerProps {
  onClose: () => void;
  onOpenConnectors: () => void;
  onSelectTool: (tool: string) => void;
  onSelectFile: (file: File) => void;
}

const ITEMS = ['photoImage', 'voice', 'webSearch', 'deepResearch', 'createImage', 'connectors'] as const;

// The composer used to have a separate always-visible upload button; that
// control now lives here, inside the "+" tools menu, next to the other
// composer capabilities.
export function ToolsPicker({ onClose, onOpenConnectors, onSelectTool, onSelectFile }: ToolsPickerProps) {
  const { language } = useTheme();
  const t = (key: string) => conversationWorkspaceStrings[language]?.[key] ?? conversationWorkspaceStrings.en[key] ?? key;

  return (
    <div className="ozira-cw-modal-backdrop" role="presentation" onClick={onClose}>
      <div className="ozira-cw-panel" role="dialog" aria-modal="true" aria-label={t('toolsTitle')} onClick={(e) => e.stopPropagation()}>
        <h3>{t('toolsTitle')}</h3>
        <ul className="ozira-cw-tool-list">
          <li>
            <label className="ozira-cw-tool-row">
              <span className="ozira-cw-row-title">{t('uploadFiles')}</span>
              <input
                type="file"
                hidden
                accept="image/png,image/jpeg,image/webp,image/gif"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) onSelectFile(file);
                  onClose();
                }}
              />
            </label>
          </li>
          {ITEMS.map((item) => (
            <li key={item}>
              <button
                type="button"
                className="ozira-cw-tool-row"
                onClick={() => {
                  if (item === 'connectors') onOpenConnectors();
                  else { onSelectTool(item); onClose(); }
                }}
              >
                <span className="ozira-cw-row-title">{t(item)}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
